import moment from "moment";
import { printQRCodeImages } from "@/api/barcoding";
import { compareValues } from "@/utils/sort-value";

export const darwinMixin = {
    methods: {
        async $_printQRFromTable(selectionRowInfo) {
            var QRIds = selectionRowInfo.map(row => row.qrCodeId);
            var filteredNullQRIds = QRIds.filter(x => x);
            if (filteredNullQRIds.length > 0) {
                var qrCodeInfo = await printQRCodeImages({ "QRCodeIds": filteredNullQRIds });
                return qrCodeInfo.items;
            }
            else {
                this.$notify({
                    title: "Warning",
                    message: "There is no QR code found in your selection",
                    type: "warning"
                });
            }
        },
        $_getQRStyle(qrCodeTypeCode, entityId) {
            var barcodeSettings = this.$store.state.barcode_settings.barcode_settings;
            var qrCodeSettingStyle = barcodeSettings.filter(setting => setting.entityId == entityId && setting.qrCodeTypeCode == qrCodeTypeCode);
            var qrStyle = {};
            if (qrCodeSettingStyle[0]) {
                qrStyle = qrCodeSettingStyle[0];
            }
            else {
                qrStyle = {
                    qrCardWidthPx: 300,
                    qrCanvasDirection: "row",
                    qrCodeImageSizePx: 120,
                    borderLinePx: 1,
                    qrCodeTextFontSizePx: 12,
                    qrCodeTextLineHeightPx: 12,
                    qrDescTextFontSizePx: 12,
                    qrDescTextLineHeightPx: 12,
                    qrImageAlignment: "left",
                    textAlignment: "left"
                };
            }
            
            var { qrCardWidthPx, qrCanvasDirection, qrCodeImageSizePx, borderLinePx, qrCodeTextFontSizePx, qrCodeTextLineHeightPx, qrDescTextFontSizePx, qrDescTextLineHeightPx, qrImageAlignment, textAlignment } = qrStyle;
            
            // auto populate some css variable based on the qrCanvasDirection
            var qrImgWidth = qrCanvasDirection == "row" ? "auto" : "100%";
            var qrInfoPadding = qrCanvasDirection == "row" ? "16px" : "0 16px 10px 16px";
            
            // populate css into the class name used
            var qrCard = `display: flex; width: ${qrCardWidthPx}px; flex-direction: ${qrCanvasDirection}; border: ${borderLinePx}px solid #a0a0a0;`;
            var qrImgContainer = `width: ${qrImgWidth}; text-align: ${qrImageAlignment};`;
            var qrCodeImg = `width: ${qrCodeImageSizePx}px; height: ${qrCodeImageSizePx}px;`;
            var qrInfoContainer = `margin: auto 0; width: 100%; box-sizing: border-box; padding: ${qrInfoPadding}; text-align: ${textAlignment}; `;
            var qrTitle = `font-size: ${qrCodeTextFontSizePx}px; line-height: ${qrCodeTextLineHeightPx}px;`;
            var qrDesc = `font-size: ${qrDescTextFontSizePx}px; line-height: ${qrDescTextLineHeightPx}px;`;

            var css = `.qrCard{${qrCard}} .qrImgContainer{${qrImgContainer}} .qrCodeImg{${qrCodeImg}} .qrInfoContainer{${qrInfoContainer}} .qrTitle{${qrTitle}} .qrDesc{${qrDesc}}`;
            return css;
        },
        async $_printQRList(hiddenContainerId, qrCodeTypeCode, entityId) {
            var qrCodeStyle = await this.$_getQRStyle(qrCodeTypeCode, entityId);
            var mywindow = window.open("", "PRINT", "height=800,width=800");
            mywindow.document.write("<html><head><title>Darwin</title>");
            mywindow.document.write(`<style>font-weight: 400; font-style: normal; }*{font-family:Gotham,Roboto,sans-serif;margin:0} .cardContainer{display: inline-block;margin:var(--space-8)}${qrCodeStyle}</style>`);
            mywindow.document.write("</head><body >");

            // Get Hidden QR ID Container
            mywindow.document.write(document.getElementById(hiddenContainerId).innerHTML);
            mywindow.document.write("</body></html>");
            mywindow.focus(); // necessary for IE >= 10*/
            // mywindow.print();
            // mywindow.close();
            return true;
        },
        $_navigateTo(pageInfo) {
            this.$router.push(pageInfo);
        },
        $_roundOfDecimal(value, decimal) {
            return value ? value.toFixed(decimal) : null;
        },
        $_getDateTimeFormat(value) {
            return value ? moment(value).local().format("lll") : "-";
        },
        $_getDateFormat(value) {
            return value ? moment(value).local().format("ll") : "-";
        },
        $_getMyrDateFormat(value) {
            return value ? moment(value).local().format("DD/MM/YYYY") : "-";
        },
        $_getTimeFormat(value) {
            return value ? moment(value).local().format("hh:mm a") : "-";
        },
        $_getDaysFromDate(value) {
            return value ? moment(value).fromNow() : "-";
        },
        $_getGPSFormat(value) {
            if (value) {
                var location = value.split(",");
                if (location && location.length > 0) {
                    var lat = parseFloat(location[0]).toFixed(6);
                    var long = parseFloat(location[1]).toFixed(6);
                    return `${lat}, ${long}`;
                }
                else return "-";
            }
            else return "-";
        },
        $_getCreationTimeFormat() {
            var creationTimeFormat = function formatter (row, col, cell, index) {
                if (cell) return moment(cell).local().format("lll");
                else return "";
            };
            return creationTimeFormat;
        },
        $_getFilterDateTimeFormat() {
            var filterDateTimeFormat = function formatter (val) {
                if (val) return moment(val).local().format("DD/MM/YYYY");
                else return "";
            };
            return filterDateTimeFormat;
        },
        $_getFilterYearFormat() {
            var filterDateTimeFormat = function formatter (val) {
                if (val) return moment(val).local().format("YYYY");
                else return "";
            };
            return filterDateTimeFormat;
        },
        $_triggerSuccessNotify(message) {
            this.$notify({
                title: "Success",
                message: message,
                type: "success"
            });
        },
        $_triggerWarningNotify(message) {
            this.$notify({
                title: "Warning",
                message: message,
                type: "warning"
            });
        },
        $_triggerErrorNotify(message) {
            this.$notify({
                title: "Error",
                message: message,
                type: "error"
            });
        },
        $_triggerInfoNotify(message) {
            this.$notify({
                title: "Info",
                message: message,
                type: "info"
            });
        },
        $_getDataName(name) {
            var d = new Date();
            var time = d.getTime();
            var myDataName = name.replace(/ /g,"_");
            var clean_dataName = myDataName.replace(/[^\w\s]/gi, "");   //clean special character just in case
            return clean_dataName + "_" + time;
        },
        $_convertPossibleValuesToArr(possibleValues) {
            if (possibleValues) {
                var tempArr = [];
                var values = possibleValues.split(";;;");
                values.forEach(value => {
                    // let format_val = value.replace(' ', '')
                    let format_val = value.trim();
                    tempArr.push({ "name": format_val, "value": format_val, "id": format_val, "label": format_val });
                });
                return tempArr;
            }
            else {
                return [];
            }
        },
        $_convertOptionsToArr(possibleValues) {
            if (possibleValues) {
                var tempArr = [];
                var values = possibleValues.split(";;;");
                values.forEach(value => {
                    // let format_val = value.replace(' ', '')
                    let format_val = value.trim();
                    tempArr.push({ "name": format_val, "value": format_val, "id": format_val, "label": format_val });
                });
                return tempArr;
            }
            else {
                return [];
            }
        },
        $_downloadMedia(url) {
            window.open(url);
        },
        $_converBoolean(bool) {
            if (typeof bool === "boolean") {
                return bool ? "Yes" : "No";
            }
            else return "-";
        },
        $_booleanConverter() {
            var convertor = function formatter (row, col, cell, index) {
                return cell ? "Yes" : "No";
            };
            return convertor;
        },
        $_numberWithCommas(x) {
            if (x) return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            else return "-";
        },
        $_maximumString(string) {
            if (string.length > 30) {
                return string.substring(0, 30) + "...";
            }
            return string;
        },
        $_openSidebarWithChecking() {
            var isInfoSidebarOpen = this.$store.state.info_sidebar.info_sidebar;
            if (!isInfoSidebarOpen) {
                this.$store.dispatch("info_sidebar/setInfoSidebar");
            }
        },
        $_closeSidebarWithChecking() {
            var isInfoSidebarOpen = this.$store.state.info_sidebar.info_sidebar;
            if (isInfoSidebarOpen) {
                this.$store.dispatch("info_sidebar/setInfoSidebar");
            }
        },
        $_handleComingSoonAlert() {
            this.$_triggerInfoNotify("Coming Soon");
        },
        $_navigateBack() {
            this.$router.go(-1);
        },
        $_filterHandler(columnName) {
            var filterHandler = function filter (value, row, column) {
                // return row[columnName] === value;
            };
            return filterHandler;
        },
        $_formatTextWithIputTypeCode(value, inputTypeCode) {
            
            switch (inputTypeCode) {
            case "BOOL":
                if (value == "true") return "Yes";
                else if (value == "false") return "No";
                else return "-";
            case "DATETIME":
                if (value) return moment(value).local().format("lll");
                else return "-";
            case "DATE":
                if (value) return moment(value).local().format("ll");
                else return "-";
            case "TIME":
                if (value) return moment(value).local().format("hh:mm a");
                else return "-";
            case "MAP_LOCATION":
                if (value) {
                    var location = value.split(",");
                    if (location && location.length > 0) {
                        var lat = parseFloat(location[0]).toFixed(6);
                        var long = parseFloat(location[1]).toFixed(6);
                        return `${lat}, ${long}`;
                    }
                    else return "-";
                }
                else return "-";
                    
            case "LABEL":
                break;
            default:
                return value || "-";
                break;
            }
        },
        $_prepareFilter(dropdownList, inputTypeCode) {
            return dropdownList.map(item => ({
                "label": this.$_formatTextWithIputTypeCode(item, inputTypeCode),
                "value": item
            }));
        },
        $_formatTableHeader(result) {
            var self = this;
            var header = [];
            result.forEach(r => {
                let inputTypeCode = r.inputType ? r.inputType.code : "";
                var tempObj = {
                    id: r.id,
                    name: "EXTENSION_DATA_" + r.id,
                    label: r.name,
                    sortable: "custom",
                    fixed: r.isDisplayName ? "left" : null,
                    filters: this.$_prepareFilter(r.dropdownList, inputTypeCode),
                    columnKey: "EXTENSION_DATA_" + r.id,
                    inputTypeCode: inputTypeCode
                    // filterMethod: this.$_filterHandler('EXTENSION_DATA_' + r.id)
                };

                // Add formatter into object for certain input type code
                switch (inputTypeCode) {
                case "BOOL":
                    tempObj.formatter = function(row, col, cell, index) {
                        return self.$_formatTextWithIputTypeCode(cell, "BOOL");
                    };
                    break;
                case "DATETIME":
                    tempObj.formatter = function(row, col, cell, index) {
                        return self.$_formatTextWithIputTypeCode(cell, "DATETIME");
                    };
                    break;
                case "DATE":
                    tempObj.formatter = function(row, col, cell, index) {
                        return self.$_formatTextWithIputTypeCode(cell, "DATE");
                    };
                    break;
                case "TIME":
                    tempObj.formatter = function(row, col, cell, index) {
                        return self.$_formatTextWithIputTypeCode(cell, "TIME");
                    };
                    break;
                case "MAP_LOCATION":
                    tempObj.formatter = function(row, col, cell, index) {
                        return self.$_formatTextWithIputTypeCode(cell, "MAP_LOCATION");
                    };
                    break;
                default:
                    break;
                }

                header.push(tempObj);
            });
            return header;
        },
        $_formatTableConfigurationHeader(columns) {
            var self = this;
            return columns.map(col => {
                let formatter = null;
                switch (col.formatTypeCode) {
                case "BOOL":
                    formatter = function(row, col, cell, index) {
                        return self.$_formatTextWithIputTypeCode(cell, "BOOL");
                    };
                    break;
                case "DATETIME":
                    formatter = function(row, col, cell, index) {
                        return self.$_formatTextWithIputTypeCode(cell, "DATETIME");
                    };
                    break;
                case "DATE":
                    formatter = function(row, col, cell, index) {
                        return self.$_formatTextWithIputTypeCode(cell, "DATE");
                    };
                    break;
                case "TIME":
                    formatter = function(row, col, cell, index) {
                        return self.$_formatTextWithIputTypeCode(cell, "TIME");
                    };
                    break;
                case "MAP_LOCATION":
                    formatter = function(row, col, cell, index) {
                        return self.$_formatTextWithIputTypeCode(cell, "MAP_LOCATION");
                    };
                    break;
                default:
                    break;
                }

                let customHtml = null;
                let code = col.formatTypeCode ? col.formatTypeCode : (col.fixedHeaderField || {}).code;
                switch (code) {
                case "SUBJECT_CAPACITY":
                    customHtml = function (row, col, cell, index) {
                        if (cell && cell.length > 0) {
                            var htmlProgressBar = "";

                            if (cell) {
                                cell.forEach(i => {
                                    let percentage = (i.count / i.maxCapacity) * 100;
                                    let formatted_percentage = percentage.toFixed(2);
                                    let inventory_color = "";
                                    if (percentage >= 80) {
                                        inventory_color = "full";
                                    }
                                    else if (percentage >= 60) {
                                        inventory_color = "medium";
                                    }
                                    else inventory_color = "low";

                                    htmlProgressBar = htmlProgressBar + `
                                            <div class="progress-bar-container">
                                                <p class="progress-name">${i.name}</p>
                                                <div class="progress-bar-line-container">
                                                    <div class="progress-bar-bg">
                                                        <div class="progress-bar-content ${inventory_color}" style="width: ${formatted_percentage}%" ></div>
                                                        <p class="progress-bar-percentage">${formatted_percentage}%</p>
                                                    </div>
                                                    <p class="progress-percentage">(${i.count}/${i.maxCapacity})</p>
                                                </div>
                                            </div>
                                        `;
                                });
                            }
                            return htmlProgressBar;
                        }
                        else return "-";
                    };
                    break;
                case "PARAGRAPH":
                    customHtml = function (row, col, cell, index) {
                        const MAX_LENGTH = 25;

                        let value = "";
                        if (cell && cell.length > MAX_LENGTH) {
                            value = cell.substr(0, MAX_LENGTH) + "...";
                        }
                        else value = cell;

                        return `<div class="editor__content paragraph-container">${value}</div>`;
                    };
                    break;
                case "SUBJECT_STATUS":
                    customHtml = function (row, col, cell, index) {
                        if (row.subjectStatus) {
                            return self.$_getSubjectStatusUI((row.subjectStatus || {}).name || "-", (row.subjectStatus || {}).colour);
                        }
                        else return "-";
                    };
                    break;
                default:
                    break;
                }

                return {
                    name: col.dataName,
                    label: col.displayName,
                    width: col.width,
                    minWidth: col.minWidth,
                    sortable: col.isSortable,
                    fixed: col.freezeColumn,
                    custom: customHtml ? true : false,
                    callbackFn: customHtml,
                    formatter: formatter
                };
            });
        },
        $_getSubjectStatusUI(name, color) {
            return `<div class="subject-status-container">
            <div class="subject-status-icon" style="background-color : ${color}"></div>
                ${name}
            </div>`;
        },
        $_convertFileBytes(currentMediaStorageBytes) {
            if (currentMediaStorageBytes) {
                var currentMedia_KB = currentMediaStorageBytes / 1024;
                var currentMedia_MB = currentMedia_KB / 1024;
                var currentMedia_GB = currentMedia_MB / 1024;

                if (currentMedia_GB > 0.01) return currentMedia_GB.toFixed(2) + "GB";
                else if (currentMedia_MB > 0.01) return currentMedia_MB.toFixed(2) + "MB";
                else return currentMedia_KB.toFixed(2) + "KB";
            }
            else return "0KB";
        },
        $_arrangeHierarchy(arry) {
            var nextParent;
            var nextSequence = 1;

            var allChildId = arry.map(arr => arr.childId);
            arry.forEach(i => {
                if (!allChildId.includes(i.parentId)) {
                    i.sequence = nextSequence++;
                    nextParent = i;
                }
            });

            arry.forEach(i => {
                arry.forEach(j => {
                    if (j.parentId == nextParent.childId) {
                        j.sequence = nextSequence++;
                        nextParent = j;
                    }
                });
            });

            return arry.sort(compareValues("sequence", "asc"));
        },
        $_beforeWindowUnload(e) {
            e.preventDefault();
            e.returnValue = "";
        },
        $_getInputComponent(inputTypeCode, isMediaFile) {
            switch (inputTypeCode) {
            case "CHECKBOX":
            case "DROPDOWN":
                return "form-select";

            case "RADIO_BUTTON":
                return "form-radio";

            case "DATE": 
                return "date-picker";

            case "TIME": 
                return "time-picker";

            case "DATETIME": 
                return "date-time-picker";

            case "BOOL": 
                return "form-boolean";

            case "CHILD_COUNT":
            case "INTEGER":
                return "form-input-number";
                
            case "CALCULATED_FIELD":
                return "calculated-field";
                
            case "CONCATENATED_FIELD":
                return "concat-field";

            case "LABEL":
                return "label-style";

            case "FLOAT":
                return "form-input-float";

            case "PHOTOS":
            case "VIDEOS":
            case "AUDIO":
            case "FILES":
                if (isMediaFile) {
                    return "form-file-picker";
                }
                else return "coming-soon-picker";

            case "SIGNATURE":
                if (isMediaFile) {
                    return "signature-pad";
                }
                else return "coming-soon-picker";

            case "RATING":
                return "rating";

            case "MAP_LOCATION":
                return "map-location";

            case "SUBJECT_BARCODE":
            case "MULTI_SUBJECT_BARCODE":
            case "SUBJECT_LIST":
            case "CHILD_BARCODE":
            case "MULTI_CHILD_BARCODE":
            case "CHILD_LIST":
                return "subject-barcode";

            case "SUBJECT_LOOKUP":
                return "subject-lookup";

            case "PARAGRAPH":
                return "tiptap-editor";

            case "SUBJECT_STATUS":
                return "subject-status";

            case "SUBJECT_LOCATED_AT":
                return "inventory-dropdown";

            default:
                return "form-input";
            }
        },
        $_checkInputType(code) {
            if (code == "TEXT_AREA") {
                return "textarea";
            }
        },
        $_checkIsRow(code) {
            if (code == "TEXT_AREA") {
                return 3;
            }
        },
        $_convertArrFromString(possibleValues, customFieldTypeCode) {
            if (possibleValues && customFieldTypeCode != "SIGNATURE" && customFieldTypeCode != "PHOTOS" && customFieldTypeCode != "VIDEOS" && customFieldTypeCode != "AUDIO" && customFieldTypeCode != "FILES" ) {
                var tempArr = [];
                var p_values = possibleValues.split(";;;");
                p_values.forEach(val => {
                    let format_val = val.trim();
                    tempArr.push({
                        "name": format_val,
                        "id": format_val,
                        "value": format_val,
                    });
                });
                return tempArr;
            }
        },
        $_checkIsCheckbox(inputTypeCode) {
            if (inputTypeCode == "CHECKBOX" || inputTypeCode == "MULTI_CHILD_BARCODE") return true;
        },
        $_getAcceptFormat(inputTypeCode) {
            switch (inputTypeCode) {
            case "SIGNATURE":
                return "image/*";
                break;
            case "PHOTOS":
                return "image/*";
                break;
            case "VIDEOS":
                return "video/*";
                break;
            case "AUDIO":
                return "audio/*";
                break;
            case "FILES":
                return "*";
                break;
            default:
                return "*";
                break;
            }
        },
        $_getMediaFileWithCustomFieldID(custom_field) {
            return custom_field.filter(item => item.inputType.code === "SIGNATURE" || item.inputType.code === "PHOTOS" || item.inputType.code === "VIDEOS" || item.inputType.code === "AUDIO" || item.inputType.code === "FILES" )
                .filter(item => item.value)
                .map(item => ({
                    customFieldId: item.id,
                    value: item.value || null,
                }));
        },
        $_convertCustomFieldToTextExtensionData(custom_filed) {
            return custom_filed.filter(item => item.inputType.code !== "SIGNATURE" && item.inputType.code !== "PHOTOS" && item.inputType.code !== "VIDEOS" && item.inputType.code !== "AUDIO" && item.inputType.code !== "FILES" )
                .map(item => ({
                    customFieldId: item.id,
                    name: item.name,
                    value: Array.isArray(item.value) ? item.value.toString() : typeof  item.value === "boolean" ? item.value : item.value || null,
                    lookupSubjectQRCode: item.lookupSubjectQRCode || null,
                    lookupCustomFieldId: item.lookupCustomFieldId,
                    lookupFixedHeaderFieldId: item.lookupFixedHeaderFieldId,
                }));
        },
        $_convertCustomFieldToMediaExtensionData(custom_filed, uuid) {
            return custom_filed.filter(item => item.inputType.code === "SIGNATURE" || item.inputType.code === "PHOTOS" || item.inputType.code === "VIDEOS" || item.inputType.code === "AUDIO" || item.inputType.code === "FILES" )
                .filter(item => item.value)
                .map(item => {
                    var formData = new FormData();
                    formData.append("CustomFieldId", item.id); 
                    formData.append("ExternalGuid", uuid || ""); 
                    formData.append("RecordingDate", moment().toISOString()); 
                    formData.append("Name", item.value.name);
                    formData.append("File", item.value);
                    return formData;
                });
        },
        $_checkIsPassingRule(comparedField, comparatorType, ruleValue) {
            var testValue = comparedField.value || comparedField.defaultValue;
            switch (comparedField.inputType.code) {
            case "BOOL":
                ruleValue = Boolean(ruleValue);
                testValue = Boolean(testValue); 
                break;
            case "FLOAT":
                testValue = parseFloat(comparedField.value);
                break;
            default:
                break;
            }
    
            switch (comparatorType) {
            case "GREATER_THAN":
                return (testValue) > ruleValue;
            case "GREATER_THAN_OR_EQUAL_TO":
                return (testValue) >= ruleValue;
            case "LESSER_THAN":
                return (testValue) < ruleValue;
            case "LESSER_THAN_OR_EQUAL_TO":
                return (testValue) <= ruleValue;
            case "EQUAL_TO":
                return (testValue) == ruleValue;
            case "NOT_EQUAL_TO":
                return (testValue) != ruleValue;
            case "CONTAINS":
                return `${testValue || ""}`.includes(ruleValue);
            case "EMPTY":
                return (testValue) == ("" || null);
            case "NOT_EMPTY":
                return (testValue) != ("" || null);
            case "STARTS_WITH":
                return `${testValue || ""}`.startsWith(ruleValue);
            case "ENDS_WITH":
                return `${testValue || ""}`.endsWith(ruleValue);
            default:
                return "";
            }
        },
    
        $_matchCondition(condition) {
            return condition == "All" ? "&&" : "||";
        },
        $_checkVisibilityRule(field, all_custom_fields) {
            if (field.customFieldVisibilityRules && field.customFieldVisibilityRules.length > 0) {
                var visibility_rule_result = true;
                var visibility_rule_expression = "";
                var visibility_match_condition = this.$_matchCondition(field.visibilityMatchCondition);

                field.customFieldVisibilityRules.forEach((rule, index) => {
                    all_custom_fields.forEach(custom_f => {
                        if (custom_f.id && (custom_f.id === rule.compareCustomFieldId)) {
                            visibility_rule_expression = visibility_rule_expression + this.$_checkIsPassingRule(custom_f, rule.comparatorType.code, rule.value) + " " + visibility_match_condition; 
                        }

                        // for preview purpose
                        if (custom_f.dataName == rule.dataName) {
                            visibility_rule_expression = visibility_rule_expression + this.$_checkIsPassingRule(custom_f, rule.comparatorType.code, rule.value) + " " + visibility_match_condition; 
                        }
                    });
                });

                // remove last AND or OR
                if (visibility_rule_expression) {
                    var vre = visibility_rule_expression.substr(0, visibility_rule_expression.length - 3);
                    return eval(vre);
                }
                else return visibility_rule_result;
                
            }
            else {
                return true;
            }
        },
        $_getIsPassingVisibilityRule(field, all_custom_fields) {
            var isPass = this.$_checkVisibilityRule(field, all_custom_fields);
            if (isPass == false) {
                this.$set(field, "value", null);
            }
            return isPass;
        },
        $_getIsCustomRequiredRules(field, all_custom_fields) {
            if (field.customFieldRequirementRules && field.customFieldRequirementRules.length > 0) {
                var required_rule_result = field.isRequired;
                var required_rule_expression = "";
                var required_match_condition = this.$_matchCondition(field.requirementMatchCondition);
    
                field.customFieldRequirementRules.forEach(rule => {
                    all_custom_fields.forEach(custom_f => {
                        if (custom_f.id && custom_f.id == rule.compareCustomFieldId) {
                            required_rule_expression = required_rule_expression + this.$_checkIsPassingRule(custom_f, rule.comparatorType.code, rule.value) + " " + required_match_condition; 
                        }
                        
                        // for preview purpose
                        if (custom_f.dataName == rule.dataName) {
                            required_rule_expression = required_rule_expression + this.$_checkIsPassingRule(custom_f, rule.comparatorType.code, rule.value) + " " + required_match_condition; 
                        }
                    });
                });

                
    
                // remove last AND or OR
                if (required_rule_expression) {
                    var rre = required_rule_expression.substr(0, required_rule_expression.length - 3);
                    field.isRequired = eval(rre);
                    return eval(rre);
                }
                else {
                    field.isRequired = required_rule_result;
                    return required_rule_result;
                }
                
            }
            else {
                return field.isRequired;
            }
        },
        $_getIsStaticCustomField(field, all_custom_fields) {
            if (field.isStatic) return true;
            else return false;
        },
        $_getLocation() {
            // Google Chrome need to call 2 times to activate GPS, temporary add this section
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(showPosition);
            } else {
                console.log("Geolocation is not supported by this browser");
            }

            async function showPosition(position) {
            }
            // End Section

            return new Promise((resolve, reject) => {
                var options = {
                    enableHighAccuracy: true,
                    timeout: 500,
                    maximumAge: 0
                };

                if (!("geolocation" in navigator)) {
                    console.log("Geolocation is not available.");
                    reject(new Error("Geolocation is not available."));
                }

                navigator.geolocation.getCurrentPosition(pos => {
                    console.log("pos", pos);
                    resolve(pos);
                }, err => {
                    console.log("err", err);
                    reject(err);
                }, options);
            });
        },
        $_getIsLabel(field) {
            if (field.inputType.code == "LABEL") return "label-form-item";
        },
        $_getCustomFieldFilter(conditionInfo) {
            var matchCondition = conditionInfo.matchCondition;
            var filters = conditionInfo.conditionRules.map(rule => ({
                "customFieldId": rule.formId,
                "customFieldName": rule.customFieldName,
                "comparatorTypeId": rule.comparatorTypeId,
                "value": rule.value,
                "comparatorCode": rule.comparatorCode,
            }));

            return {
                matchCondition,
                filters
            };
        },
        $_sortArrayObject(array, objName, sort_sequence) {
            //sort_sequence = asc, desc
            return array.sort(compareValues(objName, sort_sequence || "asc"));
        },
        $_screenResizeRefresh() {
            var self = this;
            const resizeObserver = new ResizeObserver(entries => {
                setTimeout(() => {
                    self.refreshComponent();
                }, 10);
            });

            let element = document.getElementById("spreedsheet-container");
            if (element) {
                resizeObserver.observe(element);
            }
        },
        $_checkIsEditable(code, isEditable) {
            if (code == "CONCATENATED_FIELD" || code == "CALCULATED_FIELD" || code == "DATE" || code == "DATETIME" || code == "TIME") {
                if (isEditable == false) return true;
                else return false;
            }
        },
        $_isIncludePermission(permission) {
            let granted_permissions = this.$store.state.current_user?.currentUser?.user?.grantedPermissions;
            if (granted_permissions) {
                return granted_permissions.includes(permission);
            }
            else return false;
        },
        $_getPalmPassportFormat() {
            var palmPassportFormat = function formatter (row, col, cell) {
                var trialNumber = cell?.trial?.trialNumber || "-";
                var palmNo = cell?.trialPalmNumber || "-";
                var progenyCode = cell?.progeny?.code || "-";

                return `${trialNumber}/${palmNo}(${progenyCode})`;
            };
            return palmPassportFormat;

            
        }  
    }
};


// WEBPACK FOOTER //
// ./src/mixin/darwin_mixin.js